import { useTheme } from '@mui/material';
import { Button as MUIButton } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { Copy } from '../../copy/Copy';
import { buttonSx, marginBottom16Sx } from '../../styles/Global.style';
import { Form } from '../Form/Form';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { APP_PATHS } from '../../constants/paths';
import { Loading } from '../Loading/Loading';
import { ADD_VIDEO_INIT_VALUES } from '../../constants/videos';
import { ADD_VIDEO_VALIDATION_SCHEMA } from '../../validation/videos';
import { saveVideo } from '../../helpers/saveVideo';
import { getYoutubeId } from '../../helpers/getYoutubeId';
import { useNavigate } from 'react-router-dom';

export const VideoForm = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: ADD_VIDEO_INIT_VALUES,
    validationSchema: ADD_VIDEO_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      setIsLoading(true);

      try {
        await saveVideo({
          data: {
            userId: user.id,
            youtubeId: getYoutubeId(val.youtubeUrl),
            firstName: user.firstName,
            lastName: user.lastName,
          },
          jwt: user?.jwt,
        });

        location.href = APP_PATHS.videos;
      } catch (err) {
        setIsError(true);
        setMessage(err.message);
        resetError();
      }
    },
  });

  return !isLoading ? (
    <FormContainer>
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="youtubeUrl"
          formik={formik}
          labelText={Copy.generate('Inputs.youtubeId')}
          inputType="text"
          sx={marginBottom16Sx}
        />

        <Button
          type="submit"
          fullWidth
          text={Copy.generate('Global.addVideo')}
          sx={{ ...buttonSx(theme), ...marginBottom16Sx }}
        />

        <MUIButton
          variant="outlined"
          fullWidth
          color="tertiary"
          onClick={() => navigate(-1)}
        >
          {Copy.generate('Buttons.back')}
        </MUIButton>
      </Form>
    </FormContainer>
  ) : (
    <Loading />
  );
};
